'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calRate = calRate;
exports.convert = convert;
exports.convertUnit = convertUnit;
exports.convertDisplayPricing = convertDisplayPricing;
exports.ceil = ceil;
exports.getTopUpPrice = getTopUpPrice;
exports.getDefaultCurrency = getDefaultCurrency;

var _helpers = require('./helpers');

function calRate(cur, curs) {
  if (cur in curs) {
    return curs[cur];
  }
  return 1;
}

function convert(price, cur, curs) {
  if (cur in curs) {
    var converted = price * curs[cur];
    return ['JPY', 'KRW'].includes(cur) ? Math.ceil(converted) : parseFloat(converted.toFixed(2));
  }
  return price;
}

function convertUnit(from, to, price, rates) {
  return price * rates[to] / rates[from]; // eslint-disable-line
}

function convertDisplayPricing(price, currency, rates) {
  return (0, _helpers.commaize)(convert(price, currency, rates));
}

function ceil(price, cur, curs) {
  var isConvert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (cur === 'THB') {
    var frac = price % 100 >= 90.001 && price % 100 <= 99 ? 99 : price % 100;
    return Math.ceil(Math.floor(price / 100) * 100 + frac);
  }
  if (cur in curs && isConvert) {
    if (['JPY', 'KRW', 'RUB'].indexOf(cur) >= 0) {
      return Math.ceil(price * curs[cur] / 10) * 10; //eslint-disable-line
    }
    return Math.ceil(price * curs[cur]);
  }
  if (['JPY', 'KRW', 'RUB'].indexOf(cur) >= 0) {
    return Math.ceil(price / 10) * 10;
  }
  return Math.ceil(price);
}

function getTopUpPrice(price, cur) {
  var nativePrice = price.bookingFee + price.tax;
  if (['JPY', 'KRW'].includes(cur)) return Math.ceil(nativePrice);
  return parseFloat(nativePrice.toFixed(2));
  // if (cur === price.currency) {
  //   if (cur === 'JPY') {
  //     return Math.ceil(nativePrice);
  //   }
  //   return parseFloat((nativePrice).toFixed(2));
  // }
  // if (cur in curs) {
  //   if (cur === 'JPY') {
  //     return Math.ceil(nativePrice * curs[cur]);
  //   }
  //   return parseFloat((nativePrice * curs[cur]).toFixed(2));
  // }
  // return nativePrice;
}

function getDefaultCurrency(country) {
  switch (country) {
    case 'AX':
    case 'AD':
    case 'AT':
    case 'BE':
    case 'CY':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'GF':
    case 'TF':
    case 'DE':
    case 'GR':
    case 'GP':
    case 'VA':
    case 'IE':
    case 'IT':
    case 'LU':
    case 'MT':
    case 'MQ':
    case 'YT':
    case 'MC':
    case 'ME':
    case 'NL':
    case 'PT':
    case 'RE':
    case 'BL':
    case 'MF':
    case 'SM':
    case 'SK':
    case 'SI':
    case 'ES':
      return 'EUR';
    case 'IO':
    case 'GG':
    case 'IM':
    case 'JE':
    case 'GS':
    case 'GB':
      return 'GBP';
    case 'CN':
      return 'CNY';
    case 'JP':
      return 'JPY';
    case 'SG':
      return 'SGD';
    case 'AU':
    case 'CX':
    case 'CC':
    case 'HM':
    case 'KI':
    case 'NR':
    case 'NF':
    case 'TV':
      return 'AUD';
    case 'HK':
    case 'MO':
      return 'HKD';
    case 'SE':
      return 'SEK';
    case 'BV':
    case 'NO':
    case 'SJ':
      return 'NOK';
    case 'CH':
    case 'LI':
      return 'CHF';
    case 'RU':
      return 'RUB';
    case 'MY':
      return 'MYR';
    case 'TH':
      return 'THB';
    default:
      return 'USD';
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/price.js
// module id = 60
// module chunks = 47